export class VariableContent {
  constructor(
    public vraagId: string,
    public antwoordId: string,
    public attribuutNaam: string,
    public attribuutWaarde: string
  ) {}
}
